<template>
  <div class="zhuck">
    <el-form
      v-if="!xinkz"
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <el-form-item
        prop="phoneNumber"
        style="position: relative"
        class="qinm phoneNumber"
      >
        <el-input
          class="biaojieg"
          v-model.number="ruleForm.phoneNumber"
          placeholder="请输入注册手机号码"
        />
        <span style="position: absolute; left: 12px; color: #333333">+86</span>
      </el-form-item>

      <el-form-item
        prop="telephoneCode"
        class="qinm"
        style="position: relative"
      >
        <el-input
          class="biaojieg"
          v-model="ruleForm.telephoneCode"
          autocomplete="off"
          style=""
          placeholder="请输入短信验证码"
        ></el-input>

        <el-button
          type="text"
          @click="getVerify"
          style="width: 95px; position: absolute; right: 19px"
          :disabled="(disabled = !show)"
        >
          <span style="color: #f9bd00" v-show="show">获取验证码</span>
          <span v-show="!show" class="count">{{ count }} s</span>
        </el-button>
      </el-form-item>
      <el-form-item prop="password" class="qinm" v-if="data.type == '2'">
        <el-input
          class="biaojieg"
          type="password"
          v-model="ruleForm.password"
          autocomplete="off"
          placeholder="密码为8-16位，大小写字母+数字+字符"
        ></el-input>
      </el-form-item>
      <el-form-item prop="affirmPassword" class="qinm" v-if="data.type == '2'">
        <el-input
          class="biaojieg"
          type="password"
          v-model="ruleForm.affirmPassword"
          autocomplete="off"
          placeholder="请再一次确认密码"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item prop="organizationId" style="margin-left: -3.125rem;">
        <template>
          <div style="width:100%">
            <el-radio v-model="radioID" label="1">个人</el-radio>
            <el-radio v-model="radioID" label="2">组织</el-radio>
          </div>
          <el-radio-group v-if="radioID==='2'" v-model="ortype" size="medium" @change="getorganization" >
            <el-radio-button label="2">公司</el-radio-button>
            <el-radio-button label="1">学校</el-radio-button>
          </el-radio-group>
          <el-select v-if="radioID==='2'" v-model="ruleForm.organizationId" clearable :placeholder="ortype ==='1'? '请选择学校':'请选择公司'" style="width:100%;margin-top: 10px;">
            <el-option
              v-for="item in organizationlist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item> -->
      <div>
        <el-button type="primary" @click="submitForm('ruleForm')" class="ljzc" :loading="sunmoffload">{{data.type == '1'?'立即绑定':'立即注册'}}</el-button>
      </div>

      <div class="addNewwp">
        <el-checkbox v-model="checked"></el-checkbox>
        <span>
          已阅读并同意
          <span
            style="cursor: pointer"
            @click="seeShare('/userAgreement.html')"
          >
            《服务协议》</span
          >
          和
          <span
            style="cursor: pointer"
            @click="seeShare('/legalDeclaration.html')"
            >《隐私政策》</span
          >
        </span>
      </div>
      <span></span>
      <div
        style="
          display: flex;
          width: 286px;
          margin: 7px auto 0;
          justify-content: space-between;
          font-size: 14px;
        "
      >
        <p
          style="
            margin: 0;
            color: #666666;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
          @click="weixmfun"
        >
          <img
            style="width: 20px; margin-right: 8px"
            src="../../assets/images/wixzc.png"
          />微信注册
        </p>
        <p
          style="color: #f9bd00; cursor: pointer; text-align: right"
          @click="Returnlogin"
        >
          返回登录
        </p>
      </div>

      <el-form-item class="qinm">
        <el-button @click="resetForm('ruleForm')" style="display: none" >重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 微信二维码 -->
    <div class="wxm" v-if="xinkz">
      <p
        style="
          font-size: 18px;
          font-weight: bold;
          margin-top: -3px;
          color: #333;
        "
      >
        微信注册
      </p>
      <!-- <img width="200" :src="qrUrl" class="weixmcs"/> -->
      <div ref="qrcode1" class="allse" id="qrcode1"></div>
      <p style="color: #999">请使用微信扫码注册</p>
      <!--@click="Returnphonefunction"-->
      <div class="Returnphone">
        <p
          style="
            color: #666666;
            cursor: pointer;
            text-align: left;
            font-size: 14px;
          "
          @click="Returnphonefunction"
        >
          手机号注册
        </p>
        <p
          style="
            font-size: 14px;
            color: #f9bd00;
            cursor: pointer;
            text-align: right;
          "
          @click="Returnlogin"
        >
          返回登录
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setToken, removeToken, } from "@/utils/auth";
import { GetQRcode,getorganization} from "../../api/projectSquare/xmgc";
// 生成二维码插件
import QRCode from "qrcodejs2";
export default {
  name: 'newzhuce',
  props: {
    data: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data() {
    // 验证手机号码
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    // 验证验证码
    var tel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        return callback();
      }
    };
    // 验证输入密码
    var validatePass = (rule, value, callback) => {
      var reg =
        /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("密码为(8-16位，大小写字母+数字+字符)"));
        } else {
          if (this.ruleForm.affirmPassword !== "") {
            this.$refs.ruleForm.validateField("affirmPassword");
          }
          callback();
        }
      }
    };
    // 验证再一次输入密码
    var validatePass2 = (rule, value, callback) => {
      var reg =
        /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/;
      if (value === "") {
        callback(new Error("请输入正确的密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 定义一个是不是返回登录的值
      qrUrl: process.env.API_ROOT + "wx/getQRCode",
      fanuhi: 0,
      checked: false,
      xinkz: false,
      show: true,
      count: "", // 初始化次数
      timer: null,
      ruleForm: {
        password: "",
        affirmPassword: "",
        telephoneCode: "",
        phoneNumber: "",
        organizationId:'', // 选择的学校id
      },
      ortype:1, //  1-学校 2-公司
      radioID:'1', // 身份选择
      organizationlist:[], // 推广下啦列表
      sunmoffload: false, // 立即注册 loding
      rules: {
        // 密码
        password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        // 再一次输入密码
        affirmPassword: [
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        // 验证码
        telephoneCode: [
          {
            validator: tel,
            trigger: "blur",
          },
        ],
        // 验证码
        organizationId: [
          {
            validator: tel,
            trigger: "blur",
          },
        ],
        // 手机号
        phoneNumber: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.creatQrCode();
    this.getorganization("1");
    if(this.data.type == '1'){
      this.xinkz = false;
    }

  },
  methods: {
    // 返回手机号注册
    Returnphonefunction() {
      this.xinkz = false;
    },
    // 调用生成二维码插件方法
    creatQrCode() {
      const loading1 = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector('#qrcode')
      });
      GetQRcode()
        .then((response) => {
          // this.$refs.qrcode1.innerHTML = ''; //清除二维码方法一
          let text = response.data.codedata.url;
          localStorage.setItem("scene", JSON.stringify(response.data));
          var qrcode = new QRCode(this.$refs.qrcode1, {
            text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          // qrcode.clear(); // 清除二维码方法二
          let scene = JSON.parse(localStorage.getItem("scene"));
          // 需要消息的推送，则创建连接
          this.createWebSocket(scene.sceneId);
          loading1.close();
        })
        .catch((response) => {
          loading1.close();
        });
    },
    // 与websocket服务器创建连接
    createWebSocket(userId) {
      let websocket = new WebSocket(
        process.env.WebSocket_ROOT + "webSocket/" + userId
      );
      // 连接成功时
      websocket.onopen = () => {
        // websocket.send('hello')
      };
      websocket.onmessage = (event) => {
        // 后端发送的消息在event.data中,进行提醒

        let data = event.data;
        let jsonLista = data.split("\n");
        let jsonList = {};
        jsonLista.forEach(function (item, index) {
          let temp = item.split("=");
          if (temp[1] != undefined) {
            jsonList[temp[0].trim()] = temp[1].replace(/\r/, "");
          }
        });
        setToken(jsonList.token);
        // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心
        this.judgeCenter(that.$route.path,jsonList.userRegistrationTypes);
      };
      websocket.onclose = function () {
      };
      // // 路由跳转时结束websocket链接
      this.$router.afterEach(function () {
        websocket.close();
      });
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
      window.onbeforeunload = function () {
        websocket.close();
      };
    },
    // 判断是否需要跳转到个人中心
    /*
      isroute 路由
      intype  顾客类型 ['1','2'] 数组里只有1 是接包方，只有2是发包方，1，2都存在是双重身份
    */
    judgeCenter(isroute,intype){
      localStorage.removeItem("listNameMun"); // 清除 发包方 缓存的table选择值
      /*  目前需要 登录后不跳 个人中心的
        '/Detailsonthesquare'  项目详情
        ’/classUtils/studyClass‘ 课程详情
        '/packagedetails'  任务包名称
      */
     // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心
      sessionStorage.setItem("usertype", intype);
      if(intype.length > 0){ // 有身份条件下
        if(intype.length > 1){ // 双重身份的情况下
          // this.ischoiceId = true; // 将选择进入用户中心-弹窗打开
          // 去接包方个人中心
          location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
        }else{ // 只有单个身份
          let kejq = isroute.split('.html')[0]; // 截取.html前的地址来进行判断
          if (kejq === '/Detailsonthesquare' || kejq === '/classUtils/studyClass' || kejq === '/packagedetails'){  // 不跳转
            location.reload();  // 如果已有身份则刷新页面，刷新页面登录后的数据更新
          }else{ // 都去个人中心
            if(intype[0] === '1'){
              // 去接包方个人中心
              location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
            }else if(intype[0] === '2'){
              // 去发包方个人中心
              location.href = "/empUser/empCa/accountIndex";
            }
          }
        }
      }else{ // 无任何身份条件下
        // 没得身份，去选择身份页面
        location.href = "/Selectthe.html";
      }
    },
    // 同来判断是返回登录还是关闭注册
    panplos() {
      this.$emit("changeComponent1Data", this.fanuhi);
    },
    // 返回登录
    Returnlogin() {
      this.fanuhi = 1;
      this.panplos();
    },
    // 关闭注册
    changeData() {
      this.$emit("immediatelyData",'2');
    },
    weixmfun() {
      this.creatQrCode();
      this.xinkz = true;
    },

    userAgree() {
      this.$router.push("/userAgreement");
      // window.open('#/userAgreement');
    },
    Declaration() {
      this.$router.push("/legalDeclaration");
    },
    // 提交
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert('submit!');
          if (this.checked == true) {
            this.sunmoffload = true;
            this.$set(this.ruleForm, "agreeProtocol", "Y");
            let formData = {};
            formData.password = this.ruleForm.password;
            formData.affirmPassword = this.ruleForm.affirmPassword;
            formData.telephoneCode = this.ruleForm.telephoneCode;
            formData.organizationId = this.ruleForm.organizationId;
            formData.phoneNumber = this.ruleForm.phoneNumber.toString();
            formData.agreeProtocol = this.ruleForm.agreeProtocol;
            formData.openid = this.data.openid;
            var that = this;
            axios.post("/website/message/wxSignUp", formData).then(function (res) {
                // res.data.code == 200
                // 注册成功时候传token
                if (res.data.code == 200 || res.code == 200) {
                  that.fanuhi = 0;
                  that.$emit("changeComponent1Data", that.fanuhi);
                  if (res.data.audit) { // 是否通过审核
                    that.$router.push({
                      path: "/userCheck",
                      query: {
                        audit: res.data.audit,
                      },
                    });
                  } else {
                    removeToken();
                    setToken(res.data.data.token);
                    that.$message({
                      type: "success",
                      message: "注册成功",
                    });
                    // 将手机号存进浏览器缓存
                    sessionStorage.setItem("Mobilephone", res.data.data);
                    // 关闭注册页面
                    that.changeData();
                    // 存ID
                    localStorage.setItem("userId", res.data.data.id);
                    // 存电话
                    sessionStorage.setItem(
                      "Mobilephone",
                      res.data.data.phoneNumber
                    );
                    // 存头像
                    sessionStorage.setItem(
                      "Headportrait",
                      res.data.data.headPortrait
                    );
                    that.$parent.judgeCenter(that.$route.path,res.data.data);
                    // that.$router.push("/Selectthe.html");
                  }
                } else {
                  that.$message.error(res.data.msg);
                }
              });
              this.sunmoffload = false;
          } else {
            this.$message.error("请阅读并同意《用户注册协议》和《隐私政策》！");
            return false;
          }
        } else {
          return false;
        }
      });
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 手机号验证码倒计时禁用
    getVerify() {
      // 验证手机号
      if (this.checkPhone() == false) {
        return false;
      } else {
        var phone = this.ruleForm.phoneNumber;
        var that = this;
        let url = that.data.type == '1'?"/wx/sendCode/"+ phone : "/website/sendCode/" + phone + "/2";
        axios.get(url).then(function (res) {
          if (res.data.code == 200) {
            that.$message({
              type: "success",
              message: "验证码已发送!",
            });
            const TIME_COUNT = 60; //更改倒计时时间
            if (!that.timer) {
              that.count = TIME_COUNT;
              that.show = false;
              that.timer = setInterval(() => {
                if (that.count > 0 && that.count <= TIME_COUNT) {
                  that.count--;
                } else {
                  that.show = true;
                  clearInterval(that.timer); // 清除定时器
                  that.timer = null;
                }
              }, 1000);
            }
            return;
          } else {
            that.$message.error(res.data.msg);
            return false;
          }
        });
      }
    },
    checkPhone() {
      let phone = this.ruleForm.phoneNumber;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请填写正确的手机号");
        return false;
      }
    },
    // 页面跳转
    seeShare(path) {
      let routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
    },

    // 查询所有的推广组织
    getorganization(val){
      getorganization(val).then((res) => {
        this.ruleForm.organizationId = ''
        this.organizationlist = res.data;
      })
    }
  },
};
</script>
<style scoped>
  .addNewwp >>>.el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #f9bd00;
    border-color: #f9bd00;
  }
  .phoneNumber >>> .el-input__inner {
    padding-left: 45px;
  }
  .addNewwp {
    font-size: 12px;
    width: 286px;
    margin: 0 auto;
    text-align: left;
  }
  .demo-ruleForm >>>.el-form-item__error{ left:0px;}
  .demo-ruleForm .el-form-item {
    margin-bottom: 16px;
  }
  .demo-ruleForm >>> .el-form-item__content {
    width: 100%;
  }
  .allse >>> img {
    padding-top: 0px !important;
    margin: 0 auto;
  }
</style>
<style scoped>
  .Returnphone {
    width: 260px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    color: #1473fe;
  }
  .allse {
    box-sizing: border-box;
    width: 217px;
    height: 217px;
    border: 1px solid #e4e4e4;
    margin: 48px auto 0;
    padding: 8px;
    border-radius: 4px;
  }
  .allse img {
    /* padding-top: 50px;*/
    margin: 0 auto;
  }
  .wxm {
    width: 100%;
    /* height: 33.9rem;*/
    position: absolute;
    top: 2.2rem;
    left: 0;
    background: #fff;
    z-index: 99;
  }

  .weixmcs {
    margin-top: 3.85rem;
  }

  .demo-ruleForm {
    /*margin-top: 3.125rem;*/
    margin-left: 0;
  }


  .ljzc {
    width: 286px;
    border: none;
    background: #f9bd00;
    /* margin-top: 0.625rem; */
    margin-bottom: 0.625rem;
    color: #333333;
  }

  .qinm {
    /* margin-left: 0.0625rem; */
    width: 100%;
  }

  .biaojieg {
    /* margin-left: -6.125rem; */
  }

  a {
    text-decoration: none;
    color: #f0f0f0;
  }

  .router-link-active {
    text-decoraction: none;
    color: #f0f0f0;
  }
</style>



// WEBPACK FOOTER //
// src/components/denlu/newzhuce.vue